/**
 * Fluid Health 2.0 Pillars
 */
/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var Pillar;
(function (Pillar) {
    /** I want to see my content and get working quickly (all the moments before I can put my cursor down) */
    Pillar["Open"] = "Open";
    /** I want to focus on my work and not on getting the app to do what I need */
    Pillar["Interruptions"] = "Interruptions";
    /** This pillar is used for tagging all Vetos that are not yet parented to a specific Pillar */
    Pillar["VetoMissingClassification"] = "VetoMissingClassification";
})(Pillar || (Pillar = {}));
/**
 * Fluid Health 2.0 Vetos
 */
/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var Veto;
(function (Veto) {
    /** Report failures in load and render of new or existing components */
    Veto["LoadFailed"] = "LoadFailed";
    /** Globally report unhandled errors interrupting experience */
    Veto["UnhandledError"] = "UnhandledError";
    /** Globally report unhandled rejections interrupting experience */
    Veto["UnhandledRejection"] = "UnhandledRejection";
})(Veto || (Veto = {}));
/**
 * Association of Fluid Vetos to Pillars
 */
export const VetosByPillar = [
    {
        pillar: Pillar.Open,
        vetos: [Veto.LoadFailed]
    },
    {
        pillar: Pillar.Interruptions,
        vetos: [Veto.UnhandledError, Veto.UnhandledRejection]
    }
];
/**
 * Select QoS Pillar by given Veto.
 * Reference https://office.visualstudio.com/OC/_wiki/wikis/OC.wiki/5607/QoS-2.0
 * @param veto QoS 2.0 Veto
 * @returns QoS 2.0 Pillar
 */
export function selectPillarByVeto(veto) {
    for (let entry of VetosByPillar) {
        if (entry.vetos.includes(veto)) {
            return entry.pillar;
        }
    }
    return Pillar.VetoMissingClassification;
}
//# sourceMappingURL=VetosByPillar.js.map